/* eslint-disable max-len */
import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {Link} from '../../../common/components';

import {ResponseObjectsTable} from '../tables/ResponseObjectsTable';
import {FormatTypeTable} from '../tables/FormatTypeTable';
import Table from '../tables/Table';

export const ResponseObjectsSection = () => {
    return (
        <div id="responseobjects">
            <h1>Response Objects</h1>

            <section id="responseobjects-gif">
                <h3>GIF_OBJECT</h3>

                <section>
                    <ResponseObjectsTable content={[
                        {key: <b>created</b>, type: 'float', description: `a unix timestamp representing when this post was created.`},
                        {key: <b>hasaudio</b>, type: 'boolean', description: `true if this post contains audio (only video formats support audio, the gif image file format can not contain audio information).`},
                        {key: <b>id</b>, type: 'string', description: `Tenor result identifier`},
                        {key: <b>media</b>, type: <span>{`[ { `}<Link to='#responseobjects-gifformat'>GIF_FORMAT</Link>{` : `}<Link to='#responseobjects-media'>MEDIA_OBJECT</Link>{` } ]`}</span>, description: <span>An array of dictionaries with <Link to='#responseobjects-gifformat'>GIF_FORMAT</Link> as the key and <Link to='#responseobjects-media'>MEDIA_OBJECT</Link> as the value</span>},
                        {key: <b>tags</b>, type: 'string[]', description: `an array of tags for the post`},
                        {key: <b>title</b>, type: 'string', description: `the title of the post.`},
                        {key: <b>itemurl</b>, type: 'string', description: `the full URL to view the post on tenor.com.`},
                        {key: <b>hascaption</b>, type: 'boolean', description: `true if this post contains captions`},
                        {key: <b>url</b>, type: 'string', description: `a short URL to view the post on tenor.com.`},
                    ]}/>
                </section>
            </section>

            <section id="responseobjects-category">
                <h3>CATEGORY_OBJECT</h3>

                <section>
                    <ResponseObjectsTable content={[
                        {key: <b>searchterm</b>, type: 'string', description: `The english search term that corresponds to the category`},
                        {key: <b>path</b>, type: 'string', description: `the search url to request if the user selects the category`},
                        {key: <b>image</b>, type: 'string', description: `a url to the media source for the category’s example GIF`},
                        {key: <b>name</b>, type: 'string', description: `Category name to overlay over the image. The name will be translated to match the locale of the corresponding request`},
                    ]}/>
                </section>
            </section>

            <section id="responseobjects-media">
                <h3>MEDIA_OBJECT</h3>

                <section>
                    <ResponseObjectsTable content={[
                        {key: <b>preview</b>, type: 'string', description: `a url to a preview image of the media source`},
                        {key: <b>url</b>, type: 'string', description: `a url to the media source`},
                        {key: <b>dims</b>, type: 'int[]', description: `width and height in pixels`},
                        {key: <b>size</b>, type: 'int', description: `size of file in bytes`},
                    ]}/>
                </section>
            </section>

            <section id="responseobjects-gifformat">
                <h3>GIF FORMATS</h3>
                <section className="narrow">
                    <p>
                Tenor’s API offers 3 different base formats -- GIF, MP4, and webm -- in a variety of sizes. The MP4 and webm formats will play the clip once -- except for the loopedmp4, which will play the clip a few times. The GIF format will play the clip on a continuous loop.
                    </p>
                </section>

                <section>
                    <FormatTypeTable content={[
                        {type: 'gif',
                            info: {resolution: 'High quality GIF format, largest file size available', dimensions: 'Original upload dimensions (no limits)', usage: 'Use this size for GIF shares on desktop'},
                            filters: 'default, basic, minimal',
                        },
                        {type: 'mediumgif',
                            info: {resolution: 'small reduction in size of the GIF format', dimensions: 'Original upload dimensions (no limits) but much higher compression rate', usage: 'Use this size for GIF previews on desktop'},
                            filters: 'default',
                        },
                        {type: 'tinygif',
                            info: {resolution: 'reduced size of the GIF format', dimensions: 'Up to 220 pixels wide, Height scaled with aspect ratio preserved', usage: 'Use this size for GIF previews and shares on mobile'},
                            filters: 'default, basic, minimal',
                        },
                        {type: 'nanogif',
                            info: {resolution: 'smallest size of the GIF format', dimensions: 'Up to 90 pixels tall, Width scaled with aspect ratio preserved', usage: 'Use this size for GIF previews on mobile'},
                            filters: 'default, basic',
                        },
                        {type: 'mp4',
                            info: {resolution: 'highest quality video format, largest of the video formats, but smaller than GIF', dimensions: 'Similar to gif, but padded to fit video container specifications (usually 8-pixel increments)', usage: 'Use this size for MP4 previews and shares on desktop'},
                            filters: 'default, basic, minimal',
                        },
                        {type: 'loopedmp4',
                            info: {resolution: 'highest quality video format, larger in size than mp4', dimensions: 'Same as mp4', usage: 'Use this size for mp4 shares if you want the video clip to run a few times rather than only once'},
                            filters: 'default',
                        },
                        {type: 'tinymp4',
                            info: {resolution: 'reduced size of the mp4 format', dimensions: 'Variable width and height, with maximum bounding box of 320x320', usage: 'Use this size for mp4 previews and shares on mobile'},
                            filters: 'default, basic',
                        },
                        {type: 'nanomp4',
                            info: {resolution: 'smallest size of the mp4 format', dimensions: 'Variable width and height, with maximum bounding box of 150x150', usage: 'Use this size for mp4 previews on mobile'},
                            filters: 'default, basic',
                        },
                        {type: 'webm',
                            info: {resolution: 'Lower quality video format, smaller in size than MP4', dimensions: 'Same as mp4', usage: 'Use this size for webm previews and shares on desktop'},
                            filters: 'default',
                        },
                        {type: 'tinywebm',
                            info: {resolution: 'reduced size of the webm format', dimensions: 'Same as tinymp4', usage: 'Use this size for GIF shares on mobile'},
                            filters: 'default',
                        },
                        {type: 'nanowebm',
                            info: {resolution: 'smallest size of the webm format', dimensions: 'Same as nanomp4', usage: 'Use this size for GIF previews on mobile'},
                            filters: 'default',
                        },
                    ]}/>
                </section>

                <section className="narrow">
                    <h4>Best Practices:</h4>
                    <ol className="numbered-list indent-align">
                        <li>
                    For mobile, use the nano(or tiny) sized files for previews and the tiny sized files for shares
                        </li>
                        <li>
                    If you’re using the GIF or MP4 formats only, add the following parameter to each search call: &media_filter=basic -- doing so will reduce the API response size by roughly 30%.
                        </li>

                        <li>
                    If you’re using the tinygif format only, change the parameter to: &media_filter=minimal -- doing so will reduce the API response size by roughly 50-70%.
                        </li>
                    </ol>
                </section>

                <section className="narrow no-border">
                    <h3>GIF Format Sizes</h3>
                    <p>
                The file size for each GIF format is dependent on the dimensions and length of the specific GIF selected. Therefore, the mean and medians provided below should be considered as a general guide rather than hard values.
                    </p>
                </section>

                <section>
                    <Table
                        title=""
                        headers={['GIF FORMAT', 'MEAN(KB)', 'MEDIAN(KB)']}
                        rows={[
                            ['gif', '1,472', '956'],
                            ['mediumgif', '883', '574'],
                            ['tinygif', '215', '101'],
                            ['nanogif', '77', '56'],
                            ['mp4', '125', '91'],
                            ['loopedmp4', '314', '228'],
                            ['tinymp4', '98', '81'],
                            ['nanomp4', '36', '28'],
                            ['webm', '76', '61'],
                            ['tinywebm', '57', '45'],
                            ['nanowebm', '35', '25'],
                        ]}
                    />
                </section>

            </section>

            <section id="responseobjects-codes">
                <Table
                    title="RESPONSE CODES"
                    headers={['HTTP STATUS CODE', 'DESCRIPTION']}
                    rows={[
                        ['200 or 202', 'ok or accepted; no error'],
                        ['429', 'Rate limit exceeded: This is not expected on most API calls, but the client should try to support graceful failure and retry (allow for a 30 second timeout) if this condition is encountered.'],
                        ['3xx', 'We generally do not expect redirect status codes to come from our API, but the client should try to support this.'],
                        ['404', 'Not found - bad resource'],
                        ['5xx', 'Unexpected server error'],
                    ]}
                />
            </section>

            <section id="responseobjects-errors">
                <h3>ERRORS</h3>
                <p>
            In general, known errors return an http 200 status code with attributes “error” and “code”, whereas unknown errors return non-200 status codes.
                </p>

                <Table
                    title=""
                    headers={['KEY', 'VALUE TYPE', 'DESCRIPTION']}
                    rows={[
                        ['code', 'int', 'an optional numeric code'],
                        ['error', 'string', 'a string message describing the error'],
                    ]}
                />
            </section>
        </div>
    );
};
